export const getRxPowerColorComponent = (val) => {
    // Asumsi range GPON standar: -8 s/d -28 dBm
    if (val > -15) return "text-red-400"; // Terlalu dekat (Risk of saturation)
    if (val < -26) return "text-red-400"; // Sinyal lemah
    return "text-emerald-400"; // Normal
};